export default __webpack_public_path__ + "static/media/footerLogo.62b65edc.png";